import $ from 'jquery';

class BeforeLeave {

  constructor(form) {
    this.form = form;
    this.formsData = $(form).serialize();
    this.isSubmited = false;

    $(this.form).on('submit', (event) => {
      this.isSubmited = true;
    })

    $(window).bind('beforeunload', (event) => {
      if (this.formsData != $(form).serialize() && !this.isSubmited) {
        return true
      } else {
        event = null;
      }
    });
  }
}

class BeforeLeaveControll {

  constructor() {
    this.activeForms = [];
    const beforeLeave = $('*[data-beforeleave]');

    if (beforeLeave.length) {
      beforeLeave.each((index, el) => {
        this.activeForms.push(new BeforeLeave(el));
      });
    }
  }
}

export default new BeforeLeaveControll();
